// extracted by mini-css-extract-plugin
export default {"main":"Header_main__02cpB","inner":"Header_inner__JiFFG","menu":"Header_menu__xcBu3","pills":"Header_pills__ZIjly","dash":"Header_dash__Tkm6J"};